import React from 'react';
import Highlight, { defaultProps, Language } from 'prism-react-renderer';
import theme from 'prism-react-renderer/themes/dracula';
import classnames from 'classnames';

interface CodeBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: unknown;
  children?: string;
  language?: Language;
}

export default function CodeBlock({
  children,
  className: classes,
  value,
  language = 'javascript',
}: CodeBlockProps): React.ReactElement {
  let strValue: string;
  if (value) strValue = JSON.stringify(value, null, 2);

  return (
    <Highlight theme={theme} {...defaultProps} code={strValue || children || ''} language={language}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={classnames(className, classes)} style={{ ...style, padding: '20px' }}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
}
